import React, { useEffect, useState } from 'react';
import './styles';
import { useSelector } from 'react-redux';
import Helmet from 'react-helmet';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import UIController from '../../../../../components/UI/UIController';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../../components/UI/UISearchBar';
import { STATUS_LIVE } from '../../../../../utils/Config/Constants';
import { LISTINGS_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { getFiltersProp } from '../../../../../redux/selectors/CurrentUserSelectors';
import { useHistory, useLocation } from 'react-router-dom';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_ADMIN_LISTINGS } from './queries';
import UILoadingPage from '../../../../../components/UI/UILoadingPage/UILoadingPage';

export default function AdminListings({}: AdminListingsProps) {
	const QUERY_LIMIT = 10;

	const filters = useSelector(getFiltersProp);

	const [listings, setListings] = useState<ListingType[]>();

	const history = useHistory();
	const location = useLocation();

	let props = {
		filters,
		location
	};

	let baseVariables = { order: [['updatedAt', 'DESC']], query: {} };
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, LISTINGS_TABLE_TYPE, props, baseVariables);

	const [getListings, { data: listingsData }] = useLazyQuery(GET_ADMIN_LISTINGS, {
		variables
	});

	useEffect(() => {
		(async () => {
			await getListings();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (listingsData) {
				const fetchedListings: ListingType[] = listingsData['listings'];
				setListings(fetchedListings);
			}
		})();
	}, [listingsData]);

	const renderTabComponent = () => {
		return (
			<div className='general-header-pin'>
				<UISearchBar type={UI_SEARCH_BAR_TYPES.listing} onSearchUpdated={getListings} placeholder={'search by address..'} />
			</div>
		);
	};

	const renderContent = () => {
		if (!listings) return <UILoadingPage />;

		return (
			<>
				{renderTabComponent()}
				<PLTable
					type={LISTINGS_TABLE_TYPE}
					limit={QUERY_LIMIT}
					updateTable={getListings}
					isLoading={!listings}
					data={listings}
					onSelect={(listing) =>
						history.push(
							'/listing/' +
								listing.id +
								`?${listing.services.filter((service) => service.status !== STATUS_LIVE).length > 0 ? 'listing-services' : 'photos'}`
						)
					}
					emptySetText={'No listings match your search criteria!'}
				/>
			</>
		);
	};

	return (
		<UIController bodyClassName='adminListings__body'>
			<Helmet>
				<title>Listings | Pineapple Labs</title>
				<meta property='og:title' content='Listings | Pineapple Labs' />
			</Helmet>
			{renderContent()}
		</UIController>
	);
}
